import Welcome from './Welcome.i18n'

export default Welcome
